import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Amplify } from 'aws-amplify';
import App from './App.tsx';
import { loadConfig } from './config.ts';
import './assets/styles/tokens.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5_000,
      refetchOnWindowFocus: true,
    },
  },
});

loadConfig().then((config) => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.cognito_user_pool_id,
        userPoolClientId: config.cognito_user_pool_client_id,
        loginWith: {
          oauth: {
            domain: config.cognito_domain_url.replace('https://', ''),
            scopes: ['email', 'openid', 'profile'],
            redirectSignIn: [`${window.location.origin}/callback`],
            redirectSignOut: [`${window.location.origin}`],
            responseType: 'code',
          },
        },
      },
    },
  });

  createRoot(rootEl).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  );
});
